import { AavoTextField, AavoTextFieldProps } from "src/components/common/inputFields/AavoTextField.tsx";
import {
	configuratorScalarInputValueToString,
} from "src/components/views/erp/configurator/configuratorUtils.ts";
import { ConfiguratorFieldComponentProps } from "src/components/views/erp/configurator/configuratorForm/components/field/ConfiguratorFieldComponent.tsx";
import { getConfiguratorFieldComponentLabelWithRequiredMark } from "src/components/views/erp/configurator/configuratorForm/components/field/configuratorFieldComponentUtils.ts";
import { getConfiguratorComponentErrorMessage } from "src/components/views/erp/configurator/configuratorForm/validation.ts";
import { ConfiguratorInput_InputValue_Scalar } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorInput";

interface ConfiguratorTextFieldProps
	extends ConfiguratorFieldComponentProps,
		Pick<AavoTextFieldProps, "multiline" | "minRows" | "type"> {}

export const ConfiguratorTextField = ({
	field,
	onChange,
	onSubmit,
	multiline,
	minRows,
	type,
	disabled,
}: ConfiguratorTextFieldProps) => {
	const convertValue = (newValue: string): ConfiguratorInput_InputValue_Scalar => {
		return {
			type: "SCALAR",
			propertyValue: {
				type: "string",
				value: newValue,
				label: newValue,
				fileUuid: field.imageUuid,
				isFreeInput: true,
				hiddenOnPrintouts: false,
			},
		};
	};

	return (
		<AavoTextField
			label={getConfiguratorFieldComponentLabelWithRequiredMark(field)}
			disabled={!field.enabled || disabled}
			value={configuratorScalarInputValueToString(field.currentValue)}
			onChange={(newValue) => {
				onChange(convertValue(newValue));
			}}
			onSubmit={async (newValue) => {
				await onSubmit(convertValue(newValue));
			}}
			error={getConfiguratorComponentErrorMessage(field)}
			sx={{
				flex: 1,
			}}
			multiline={multiline}
			minRows={minRows}
			type={type}
		/>
	);
};
